<template src='./filterPortlet.pug' lang='pug'></template>

<script>
export default {
  name: 'FilterPortlet',

  props: {
    portletTitle: {
      default: function () {
        return this.$t('filterPortlet.defaultTitle')
      }
    },
    showHeader: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>
.ui-widget-content {
  font-family: 'Inter', sans-serif;
  border: 1px solid #ddd;
  background: #fff;
  color: #444;
  padding: 10px 30px 20px 30px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.ui-widget-content a {
  color: #444;
}

.ui-widget-header {
  text-transform: uppercase;
  text-shadow: #fff 1px 1px 0;
}

.ui-widget-header,
#tooltip {
  border: 1px solid #c6c6c6;
  background: #ddd;
  color: #444;
  padding: 10px;
}

.ui-widget-header a {
  color: #444;
}

.ui-widget-header-new-layout>.ui-widget-header-titulo {
  float: left;
  background-color: #39b8bb;
  padding: 10px 11px 10px 11px;
  text-transform: initial;
  font-size: 14px;
}

.ui-widget-header-new-layout {
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  letter-spacing: 0.08em;
  font-weight: bold;
  text-transform: uppercase;
  text-shadow: none;
  border: none;
  margin: 0;
  padding: 0;
  height: 40px;
}

.ui-widget-header-new-layout,
#tooltip {
  background: #17375f;
  color: #fff;
  padding: 10px 10px 10px 30px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.ui-widget-header-new-layout a {
  color: #fff;
}

.ui-widget-header-new-layout>span.ui-icon-circle-arrow-s {
  background-size: 18px;
  background-repeat: no-repeat;
  background-color: #34537b;
  background-position: center;
  -webkit-transition: background-image 0.2s ease-in-out;
  transition: background-image 0.2s ease-in-out;
  height: 100%;
  margin: 0 !important;
  padding: 0 12px;
  top: 0px !important;
  right: 0 !important;
}

.ui-widget-header-new-layout>span.ui-icon-circle-arrow-n {
  background-size: 18px;
  background-repeat: no-repeat;
  background-color: #34537b;
  background-position: center;
  -webkit-transition: background-image 0.2s ease-in-out;
  transition: background-image 0.2s ease-in-out;
  height: 100%;
  margin: 0 !important;
  padding: 0 12px;
  top: 0px !important;
  right: 0 !important;
}

.ui-widget-header-new-layout>span.ui-icon-gear {
  background-size: 18px;
  background-repeat: no-repeat;
  background-position: center;
  -webkit-transition: background-image 0.2s ease-in-out;
  transition: background-image 0.2s ease-in-out;
  height: 100%;
  margin: 0 !important;
  padding: 0 12px;
  top: 0px !important;
  right: 40px !important;
}

.ui-widget-container-titulo {
  float: left;
  background-color: #17375f;
  text-transform: initial !important;
  color: #ffffff !important;
  font-size: 14px !important;
  font-weight: bold !important;
}

.portlet {
  border-radius: 25px;
}
</style>



// WEBPACK FOOTER //
// FilterPortlet.vue?638354c7